import type { CoreBusinessItem } from '../types';

interface CoreBusinessSectionProps {
  items: CoreBusinessItem[];
}

export default function CoreBusinessSection({ items }: CoreBusinessSectionProps) {
  if (!items || items.length === 0) {
    return null;
  }

  const formatIndex = (idx: number) => {
    return String(idx + 1).padStart(2, '0');
  };

  return (
    <div>
      {/* 标题区域 */}
      <div className="px-4 py-3 border-b border-gray-100 flex items-center">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-bold text-gray-900">核心业务</h3>
          <p className="text-xs text-gray-400 tracking-widest ml-1">CORE BUSINESS</p>
        </div>
      </div>

      {/* 业务列表 */}
      <div className="px-4 pb-4 space-y-4 mt-4">
        {items.map((item, idx) => (
          <div key={item.id} className="flex gap-3 pb-2" style={{ borderBottom: idx < items.length - 1 ? '1px dashed #eee' : 'none' }}>
            {/* 数字编号 */}
            <div className="text-white flex items-center justify-center shrink-0"
              style={{ width: '32px', height: '32px', borderRadius: '4px',
                background: 'linear-gradient(135deg, #1da9ff 0%, #0066cc 100%)', fontSize: '12px',fontWeight: 'bold',marginRight: '12px'
               }}
            >
              {formatIndex(idx)}
            </div>
            
            {/* 内容区域 */}
            <div className="flex-1 min-w-0">
              <h4 className="text-[14px] font-bold text-[#333333] mb-1.5">
                {item.title || `业务 ${idx + 1}`}
              </h4>
              {item.description && (
                <div
                  className="text-xs text-gray-600 leading-relaxed rich-text-preview"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
